// Shared constants for the AI incident chat module.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SEV_META = {
  s1: { label: "S1 · Line Stop", color: "#E24B4A", bg: "rgba(226,75,74,0.12)" },
  s2: { label: "S2 · Critical", color: "#f39c12", bg: "rgba(243,156,18,0.12)" },
  s3: { label: "S3 · High", color: "#185FA5", bg: "rgba(24,95,165,0.12)" },
  s4: { label: "S4 · Standard", color: "#9198b0", bg: "rgba(145,152,176,0.12)" },
};

export const CATEGORY_LABEL = {
  quality_lock: "Quality Lock",
  inbound_transport_delay: "Inbound Transport Delay",
  line_stoppage: "Line Stoppage — Active",
  packaging_shortage: "Packaging Shortage",
  raw_material_shortage: "Raw Material Shortage",
  customs_border_hold: "Customs / Border Hold",
  jis_sequence_error: "JIS Sequence Error",
  warehouse_damage: "Warehouse Damage / Loss",
};

export const CATEGORY_TO_TEMPLATE_KEY = {
  jis_sequence_error: "jis",
  line_stoppage: "stoppage",
  quality_lock: "quality",
  inbound_transport_delay: "transport",
  packaging_shortage: "packaging",
  customs_border_hold: "customs",
  warehouse_damage: "damage",
  raw_material_shortage: "material",
};

export const CONFIDENCE_META = {
  low: { label: "LOW", color: "#9198b0", bg: "rgba(145,152,176,0.18)" },
  medium: { label: "MEDIUM", color: "#f3b14a", bg: "rgba(243,177,74,0.18)" },
  high: { label: "HIGH", color: "#4ed084", bg: "rgba(78,208,132,0.18)" },
};

export const EMPTY_EXTRACTED = {
  title: null,
  category: null,
  severity: null,
  description: null,
  affected_line: null,
  affected_part_numbers: [],
  estimated_units_impact: null,
  estimated_hours_impact: null,
  estimated_eur_loss: null,
  suggested_parties: [],
};

export const GREETING =
  "Hi — I'm your SITROOM incident assistant. Describe what happened and I'll set up the incident report for you.";

export const MAX_TURNS = 8;

// Iter33: static quick-start chips. Each is a one-click prefill that
// IMMEDIATELY sends the message (no separate "send" tap needed). Texts are
// in Hungarian per the spec — the AI extractor is language-agnostic.
export const AI_CHAT_STATIC_CHIPS = [
  { icon: "🔴", label: "Line stoppage", text: "A termelősor leállt" },
  { icon: "⚠", label: "Quality lock", text: "Minőségi zárolás szükséges" },
  { icon: "🚚", label: "Transport delay", text: "Szállítási késés történt" },
  { icon: "📦", label: "JIS sequence error", text: "JIS szekvencia hiba" },
];
